
import dayjs from 'dayjs';
import {modulesData} from 'data/modules-data';


/**
 * Create new module in player modules array
 * @param {string} moduleId 
 * @returns 
 */
export function createNewPlayerModule(moduleId, cookieData = null) {
	const moduleData = modulesData.find((m) => {return m.id === moduleId;});
	const taskId = (moduleData.tasks && moduleData.tasks.length > 0 ? moduleData.tasks[0].id : null);
	const sessionTemplate = {
		isCompleted: (cookieData && cookieData.sessionIsCompleted ? cookieData.sessionIsCompleted : false),
		started: (cookieData && cookieData.started ? cookieData.started : dayjs(new Date()).format('YYYY-MM-DD')),
		currentTaskId: (cookieData && cookieData.currentTaskId ? cookieData.currentTaskId : taskId),
		points:  (cookieData && cookieData.ponts ? cookieData.points : 0),
		tasks: []
	};
	const playerModule = {
		moduleId: moduleId,
		maxStars: 0,
		maxPoints: 0,
		completedDate: null,
		sessions: [sessionTemplate],
	};
	return playerModule;		
}

/**
 * Get player all modules data
 * @param {object} playerData 
 * @returns {array}
 */
export function getPlayerModulesData(playerData) {
	let playerModulesData = (playerData && playerData.modules 
		? [...playerData.modules]
		: []
	);
	return playerModulesData;
}

/**
 * Get index of player module data
 * @param {object} playerData
 * @param {string} moduleId
 * @returns {number} moduleIndex
 */
export function getPlayerModuleIndex(playerData, moduleId) {
	const playerModulesData = getPlayerModulesData(playerData);
	const moduleIndex = playerModulesData.findIndex((m) => {return m.moduleId === moduleId;});
	return moduleIndex;
}

/**
 * Get player module data
 * @param {string} moduleId
 * @param {object} playerData 
 * @returns {object || null}
 */
export function getPlayerModuleData(moduleId, playerData) {
	const playerModulesData = getPlayerModulesData(playerData);
	const playerModuleData = (playerModulesData.some((m) => {return m.moduleId === moduleId;})
		? playerModulesData.find((m) => {return m.moduleId === moduleId;})
		: null
	);
	return playerModuleData;
}

/**
 * Check if a module is unlocked
 * @param {string} moduleId 
 * @param {object} playerData 
 * @returns 
 */
export function checkIfModuleIsUnlocked(moduleId, playerData) {
	let moduleIsUnlocked = false;
	const moduleData = modulesData.find((m) => {return m.id === moduleId;});

	if (moduleData) {
		moduleIsUnlocked = true;
		
		if (moduleData.requiredModuleIds && moduleData.requiredModuleIds.length > 0) {
			moduleData.requiredModuleIds.forEach((moduleId, index) => {
				if (!moduleIsUnlocked) return;

				/* Check if required module has been completed */
				const playerRequiredModuleData = getPlayerModuleData(moduleId, playerData);
				const requiredModuleIsCompleted = 
					Boolean(playerRequiredModuleData && playerRequiredModuleData.completedDate);
				if (!requiredModuleIsCompleted) {
					moduleIsUnlocked = false;
				}
			});
		}
	}

	return moduleIsUnlocked;
}

/**
 * Get index of current player session
 * @param {array} playerModulesData 
 * @param {string} moduleId 
 * @returns {number}
 */
export function getPlayerModuleSessionIndex(playerData, moduleId) {
	const playerModuleData = getPlayerModuleData(moduleId, playerData); 
	if (playerModuleData && playerModuleData.sessions && playerModuleData.sessions.length > 0) {
		return (playerModuleData.sessions.length - 1);
	}
	return -1;
}

/**
 * Get player data for current module session
 * @param {array} playerModulesData 
 * @param {string} moduleId 
 * @returns 
 */
export function getPlayerModuleSessionData(playerData, moduleId) {
	const playerModuleData = getPlayerModuleData(moduleId, playerData); 
	if (playerModuleData && playerModuleData.sessions && playerModuleData.sessions.length > 0) {
		return playerModuleData.sessions[playerModuleData.sessions.length - 1];
	}
	return null;
}

/**
 * Check if player has completed a module
 * @param {object} playerData 
 * @param {string} moduleId 
 * @returns 
 */
export function checkIfModuleIsCompleted(playerData, moduleId) {
	let isCompleted = false;

	const playerModuleData = getPlayerModuleData(moduleId, playerData); 
	if (playerModuleData && playerModuleData.sessions) {
		if (playerModuleData.sessions.length > 1) {
			isCompleted = true;
		} else {
			const playerModuleSessionData = getPlayerModuleSessionData(playerData, moduleId);
			isCompleted = checkIfModuleSessionIsCompleted(playerModuleSessionData);
		}
	}
	return isCompleted;
};

/**
 * Get module completion date
 * @param {object} playerData 
 * @param {string} moduleId 
 * @returns 
 */
export function getModuleCompletedDate(playerData, moduleId) {
	let completedDate = null;
	const playerModuleData = getPlayerModuleData(moduleId, playerData);
	if (playerModuleData && playerModuleData.completedDate) {
		completedDate = playerModuleData.completedDate;
	}
	return completedDate;
}

/**
 * Check if module session is completed
 * @param {object} playerModuleSessionData 
 * @returns 
 */
export function checkIfModuleSessionIsCompleted(playerModuleSessionData) {
	let sessionIsCompleted = false;
	if (playerModuleSessionData && playerModuleSessionData.isCompleted === true) sessionIsCompleted = true;
	return sessionIsCompleted;
}




/**
 * Get the last played taskId of the module (null if player has just started the module)
 * @param {string} moduleId 
 * @param {object} playerData 
 * @returns 
 */
export function getLastPlayedTaskId(moduleId, playerData) {
	let taskId = null;
	const moduleData = modulesData.find((m) => {return m.id === moduleId;});
	if (moduleData.tasks && moduleData.tasks.length > 0) {
		/* Default: First task in module */
		taskId = moduleData.tasks[0].id;
		const playerModuleSessionData = getPlayerModuleSessionData(playerData, moduleId);
		if (playerModuleSessionData) {
			if (
				playerModuleSessionData.currentTaskId &&
				moduleData.tasks.some((m) => {return m.id === playerModuleSessionData.currentTaskId;})
			) {
				/* Last played task */
				taskId = playerModuleSessionData.currentTaskId;
			} else if (playerModuleSessionData.isCompleted) {
				/* Player has completed module, go to last task in module */
				taskId = moduleData.tasks[moduleData.tasks.length - 1].id;
			}
		}
	}

	return taskId;
}

/**
 * Start new module session
 * @param {string} moduleId 
 * @param {object} playerData 
 * @returns 
 */
export function startNewSession(moduleId, playerData) {
	const playerModulesData = getPlayerModulesData(playerData);
	const moduleIndex = playerModulesData.findIndex((m) => {return m.moduleId === moduleId;});
	if (moduleIndex < 0) return null;
	if (!playerModulesData[moduleIndex].hasOwnProperty('sessions')) return null;
	const moduleData = modulesData.find((m) => {return m.id === moduleId;});
	const	taskId = (moduleData.tasks && moduleData.tasks.length > 0 ? moduleData.tasks[0].id : null);
	const sessionTemplate = {
		isCompleted: false,
		started: dayjs(new Date()).format('YYYY-MM-DD'),
		currentTaskId: taskId,
		points: 0,
		milisecondsPlayed: 0,
		tasks: []
	};
	playerModulesData[moduleIndex].sessions.push(sessionTemplate);

	return playerModulesData;
}